<template>
  <div class="faq-area pb-100">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
          <div class="faq-content">
            <span class="top-title">{{ c.top_title }}</span>
            <h2 class="text-white">{{ c.title }}</h2>
          </div>
          <div class="accordion">
            <div v-for="(item, index) in c.items" :key="index" class="accordion-item"
              :class="{ active: activeIndex === index }">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)">
                  {{ item.question }}
                </button>
              </h2>
              <div class="accordion-collapse collapse show" v-show="activeIndex === index">
                <div class="accordion-body"><p>{{ item.answer }}</p></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
          <div class="faq-img"><img :src="c.image_url || faqImg" alt="faq" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);
    const { content: c } = useContent("faq", {
      top_title: "FAQ", title: "Find what you want to know",
      image_url: "",
      items: [
        { question: "Devices that you Support?", answer: "No need 'Tech Savvy'. You just download the app on your TV." },
        { question: "How I get technical support?", answer: "No need 'Tech Savvy'. You just download the app on your TV." },
        { question: "How long before I can use the service?", answer: "No need 'Tech Savvy'. You just download the app on your TV." },
        { question: "What's about Refund Policy?", answer: "No need 'Tech Savvy'. You just download the app on your TV." },
      ],
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const faqImg = require("@/assets/images/faq.png");
    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };
    return { c, faqImg, activeIndex, toggleAccordion };
  },
});
</script>
